import { useLazyQuery } from '@apollo/client';

import GetVerifiableFieldsQuery from '@/graphql/contracts/getVerifiableFields.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetVerifiableFields,
  GetVerifiableFieldsVariables
} from '@/graphql/contracts/_generated_/getVerifiableFields.query';
import { EntityTypeEnum } from '@/graphql/contracts/_generated_/contracts';

export function useGetVerifiableFields() {
  const [_getVerifiableFields, { loading, data }] = useLazyQuery<
  GetVerifiableFields,
  GetVerifiableFieldsVariables
  >(
    GetVerifiableFieldsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
    }
  );

  const getVerifiableFields = (reasonCode: string, entityType: EntityTypeEnum) => {
    _getVerifiableFields({
      variables: {
        reasonCode,
        entityType,
      }
    });
  };

  return {
    getVerifiableFields,
    verifiableFields: data?.verifiableFields ?? [],
    isLoading: loading,
  } as const;
}
